import React, { useMemo } from 'react'
import ChiNhanhBranchLabel from './ChiNhanhBranchLabel'
import { groupBranchesByDuAnForPicker } from '@utils/chiNhanhUtils'

type Props = {
  branches: readonly unknown[]
  activeBranchId?: number | string | null
  onSelect: (item: unknown) => void
}

/** Overlay chọn chi nhánh: mỗi dự án — lưới 3 cột, ưu tiên điền theo hàng. */
const ChiNhanhBranchPickerOverlay: React.FC<Props> = ({ branches, activeBranchId, onSelect }) => {
  const groups = useMemo(() => groupBranchesByDuAnForPicker(branches), [branches])

  if (groups.length === 0) {
    return (
      <div className="chi-nhanh-picker-overlay chi-nhanh-picker-overlay--empty">
        Không có chi nhánh
      </div>
    )
  }

  return (
    <div className="chi-nhanh-picker-overlay" role="menu">
      {groups.map((group) => (
        <section key={group.duAnId} className="chi-nhanh-picker-group" aria-label={group.duAnLabel}>
          <div className="chi-nhanh-picker-group__title">{group.duAnLabel}</div>
          <div className="chi-nhanh-picker-group__grid">
            {group.branches.map(({ key, item, cellLines }) => {
              const row = item as { id?: number | string }
              const isActive = activeBranchId != null && String(row.id) === String(activeBranchId)
              return (
                <button
                  key={key}
                  type="button"
                  role="menuitem"
                  className={`chi-nhanh-picker-cell${isActive ? ' chi-nhanh-picker-cell--active' : ''}`}
                  onClick={() => onSelect(item)}
                >
                  <ChiNhanhBranchLabel line1={cellLines.line1} line2={cellLines.line2} />
                </button>
              )
            })}
          </div>
        </section>
      ))}
    </div>
  )
}

export default ChiNhanhBranchPickerOverlay
